<button *ngIf="!isVideoOpen" (click)="photoStart()" [disabled]="isLocked" class="button">{{getShowCameraText()}}</button>
<div [class.is-hidden]="!isVideoOpen">
    <video #video width="640" height="480" autoplay [attr.aria-label]="getText('sr_camera_preview')"></video>
</div>
<button *ngIf="isVideoOpen" (click)="photoSnap()" [disabled]="isLocked" class="button">{{getTakePictureText()}}</button>
<br><br>
<div [class.is-hidden]="!isSnapTaken">
    <canvas #canvas style="width: 14em;" width="640" height="480" role="img" [attr.aria-label]="getText('sr_camera_capture')"></canvas>
</div>
<p class="sr-only" role="status" aria-live="polite" aria-atomic="true">{{ statusMessage }}</p>
